import React from "react";

interface CheckCircleProps {
  width?: number;
  height?: number;
}

/** Green circle checkmark with drop shadow — matches the existing client app's CheckCircle */
export const CheckCircle = ({ width = 48, height = 48 }: CheckCircleProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#check_circle_shadow)">
      <path
        d="M16.0332 32C16.0332 18.7452 26.7784 8 40.0332 8C53.288 8 64.0332 18.7452 64.0332 32C64.0332 45.2548 53.288 56 40.0332 56C26.7784 56 16.0332 45.2548 16.0332 32Z"
        fill="#22C55E"
      />
      <path
        d="M40.0332 9C52.7358 9 63.0332 19.2975 63.0332 32C63.0332 44.7025 52.7358 55 40.0332 55C27.3307 55 17.0332 44.7025 17.0332 32C17.0332 19.2975 27.3307 9 40.0332 9Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M37.18 40C36.8104 39.9989 36.458 39.8443 36.2067 39.5734L29.7267 32.68C29.2222 32.1425 29.2491 31.2978 29.7867 30.7934C30.3242 30.289 31.1689 30.3158 31.6733 30.8534L37.1667 36.7067L48.38 24.44C48.6901 24.0539 49.1886 23.8715 49.6746 23.9662C50.1607 24.0609 50.5542 24.4172 50.6966 24.8915C50.839 25.3658 50.7068 25.8799 50.3533 26.2267L38.1667 39.56C37.9177 39.8359 37.5649 39.9954 37.1933 40H37.18Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="check_circle_shadow"
        x="0.0332031"
        y="0"
        width="80"
        height="80"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.133333 0 0 0 0 0.772549 0 0 0 0 0.368627 0 0 0 0.24 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
